<script lang="ts">
    import type {Datatype} from 'src/typings';
    import KpDatatypedValue from './KpDatatypedValue.svelte';

    export let datatype: Datatype;
    export let value;
    export let fallback = '';
</script>

{#if Array.isArray(value) && value.length > 0}
    {#each value as item, index}
        <span>
            <KpDatatypedValue value={item} {datatype} {fallback}/>
            {#if index < (value.length - 1)},{/if}
        </span>
    {/each}
{:else}
    <span>{fallback}</span>
{/if}